import React, {createContext, ReactNode, useContext, useState} from "react"
import {SubscribedActivity} from "../models"

type MessageServiceProps = {
    messages: SubscribedActivity[],
    unreadMessages: SubscribedActivity[],
    children: ReactNode
}

type MessageServiceContext = {
    setMessages: (value: (((prevState: SubscribedActivity[]) => SubscribedActivity[]) | SubscribedActivity[])) => void,
    setUnreadMessages: (value: (((prevState: SubscribedActivity[]) => SubscribedActivity[]) | SubscribedActivity[])) => void,
    getMessages: () => SubscribedActivity[] | undefined,
    getUnreadMessages: () => SubscribedActivity[] | undefined,
    getMessageCount: () => number,
    getUnreadMessageCount: () => number
}

export const useMessageService = (): MessageServiceContext => {
    const context = useContext(MessageServiceContext)

    if (context === null) {
        throw new Error(
            "MessageServiceContext was not provided. Make sure your component is a child of the MessageService")
    }

    return context
}

const MessageServiceContext = createContext(null)

const MessageService = (
    {
        messages: initialMessages,
        unreadMessages: initialUnreadMessages,
        children
    }: MessageServiceProps
) => {
    const [messages, setMessages] = useState<SubscribedActivity[]>(initialMessages)
    const [unreadMessages, setUnreadMessages] = useState<SubscribedActivity[]>(initialUnreadMessages)

    const getMessages = (): SubscribedActivity[] => {
        return messages
    }

    const getUnreadMessages = (): SubscribedActivity[] => {
        return unreadMessages
    }

    const getMessageCount = (): number => {
        return messages?.length ?? 0
    }

    const getUnreadMessageCount = (): number => {
        return unreadMessages?.length ?? 0
    }

    const MessageService = {
        setMessages,
        setUnreadMessages,
        getMessages,
        getUnreadMessages,
        getMessageCount,
        getUnreadMessageCount
    }

    return <MessageServiceContext.Provider value={ MessageService }>
        { children }
    </MessageServiceContext.Provider>
}

export default MessageService
